var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-table',{attrs:{"fields":_vm.fields,"baseURL":_vm.VUE_APP_MARKETPLACE_LINK,"list_url":"admin/withdrawals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }